import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageService } from 'src/app/service/token-storage.service';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit{

  authUser:any = null;

  constructor(
    public tokenStorage:TokenStorageService,
    private router: Router,
    public authApi:AuthService
  ) { }

  ngOnInit () {
    this.getProfile();
  }


  getProfile(){
    this.authApi.profile().subscribe({
      next:(res:any) =>{
        console.log('97',res);
        this.authUser = res.user;
      }
    });
  }

  logout(){
    this.tokenStorage.signOut();
    this.router.navigate(['/login']);
  }

}
